module.exports = "/legacy/868affdd066ddecd5d297f4869efc49a.svg";